import { Form, Input, Row, Col, Switch, Select, DatePicker } from 'antd';
import { useEffect, useRef, useState } from 'react';
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from "../../universal/getList";
import dayjs from 'dayjs';

const WebProductOrderEdit = (props: any) => {
    const apiId = 'webProductOrder';
    const [form] = Form.useForm(); //form 
    const { defaultService } = props;
    const ref = useRef<any>(undefined);

    const [shopData, setShopData] = useState<any>();
    const [orderStatusData, setOrderStatusData] = useState<any>();

    useEffect(() => {
        if (ref.current) {
            ref.current.getRow?.then(async (res: any) => {
                if (typeof res === 'undefined') { return }
                if (res.success === true) {
                    const shopId = res.data.shopId;
                    // const orderStatusId = res.data.orderStatusId;
                    // const unionId = res.data.wxUser.id;
                    // console.log('res.data');
                    // console.log(res.data);
                    fetchApi.GET(defaultService,
                        {
                            apiId: 'shop',
                            apiVariable: shopId
                        }).then(res => {
                            if (res.success) {
                                setShopData([res.data]);
                            }
                        })
                    fetchApi.GET(defaultService,
                        {
                            apiId: 'generalData',
                            apiVariable: 'orderStatus',
                            apiExtend: 'showList',
                            // apiData: {
                            //     id: orderStatusId
                            // }
                        }).then(res => {
                            if (res.success) {
                                setOrderStatusData(res.data);
                            }
                        })
                }
            })
        }

    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId: 'webProductOrder',
        dateColumnName: ['orderDate', 'lastReceiptDate'],
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={12}>
                        <Form.Item
                            label="id"
                            name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="微信"
                            name="unionId">
                            <Select
                                showSearch
                                placeholder="微信unionId"
                                optionFilterProp="children"
                                disabled={true}
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="店铺"
                            name="shopId">
                            <Select
                                showSearch
                                placeholder="店铺"
                                optionFilterProp="children"
                                disabled={true}
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(shopData, 'shopName')}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="订单状态"
                            name="orderStatusId">
                            <Select
                                showSearch
                                placeholder="订单状态"
                                optionFilterProp="children"
                                disabled={true}
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(orderStatusData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="下单时间"
                            name="orderDate"
                            initialValue={dayjs(new Date())}>
                            <DatePicker
                                disabled={true}
                                format="YYYY-MM-DD HH:mm:ss"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="最后收货确认"
                            name="lastReceiptDate"
                            initialValue={dayjs(new Date())}>
                            <DatePicker
                                format="YYYY-MM-DD HH:mm:ss"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="支付单号"
                            name="orderPayId">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="允许修改地址"
                            name="allowChangeAddress"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="是"
                                unCheckedChildren="否" />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="允许修改备注"
                            name="allowChangeMemo"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="是"
                                unCheckedChildren="否" />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>

                </Row>
            )
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default WebProductOrderEdit;